import { createSlice } from "@reduxjs/toolkit";

export enum StatusCode {
  // Booking
  Pending = "pending",
  PendingChange = "pending_change",
  PendingCancellation = "pending_cancellation",
  WaitingList = "waiting_list",
  Confirmed = "confirmed",
  Cancelled = "cancelled",
  Failed = "failed",

  // Ticket
  CheckedIn = "checked_in",
  NoShow = "no_show",
  LateCancellation = "late_cancellation",

  // Invoice
  Issued = "issued",
  NotIssued = "not_issued",
}

export enum StatusGroupCode {
  Booking = "booking",
  Ticket = "ticket",
  Invoice = "invoice",
}

export type StatusGroup = {
  id: number;
  code: StatusGroupCode;
  name: string;
};

export type Status = {
  id: number;
  code: StatusCode;
  name: string;
  description: string;
  group: StatusGroup;
};

type InitialState = {
  data: Status[];
  isLoading: boolean;
};

const initialState: InitialState = {
  data: [],
  isLoading: false,
};

const statusSlice = createSlice({
  name: "statusSlice",
  initialState,
  reducers: {
    fetchData: (state) => {
      state.isLoading = true;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default statusSlice;
